// extracted by mini-css-extract-plugin
export var searchHeader = "_7s-0";
export var searchHeaderDark = "_7s-1";